export const GET_RESPONSE_FOR_GEN_AI_QUERY = "GET_RESPONSE_FOR_GEN_AI_QUERY";
export const GET_RESPONSE_FOR_GEN_AI_QUERY_SUCCESS =
  "GET_RESPONSE_FOR_GEN_AI_QUERY_SUCCESS";
export const GET_RESPONSE_FOR_GEN_AI_QUERY_FAILED =
  "GET_RESPONSE_FOR_GEN_AI_QUERY_FAILED";
